import type { ReactNode } from "react";

interface FeatureItemProps {
  icon: ReactNode;
  message?: ReactNode;

}

export const FeatureItem = ({
  icon,
  message
}: FeatureItemProps) => {
  return (
    <div className="cy:flex cy:items-start cy:gap-4">
      <div className="cy:w-5 cy:h-5 cy:rounded-full cy:flex cy:items-center cy:justify-center cy:flex-shrink-0">
        {icon}
      </div>
      <span className="cy:text-sm">{message}</span>
    </div>
  );
}; 